import { Box, Container } from "@mui/material";
import { MAIN } from "../../constants";

const SaleSection = () => {
  return (
    <section id="sale">
      <Container>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="sale-bar">
            <div
              className="bar-column left"
              onClick={() =>
                MAIN.preSale.url && window.open(MAIN.preSale.url, "_blank")
              }
            >
              <h4 style={{ margin: 0 }}>{MAIN.preSale.title}</h4>
              <h5 style={{ margin: 0 }}>{MAIN.preSale.subtitle}</h5>
              <span style={{ fontSize: 12 }}>{MAIN.preSale.content}</span>
            </div>
            <div
              className="bar-column"
              onClick={() =>
                MAIN.publicSale.url &&
                window.open(MAIN.publicSale.url, "_blank")
              }
            >
              <h4 style={{ margin: 0 }}>{MAIN.publicSale.title}</h4>
              <h5 style={{ margin: 0 }}>{MAIN.publicSale.subtitle}</h5>
              <span style={{ fontSize: 12 }}>{MAIN.publicSale.content}</span>
            </div>
          </div>
        </Box>
      </Container>
    </section>
  );
};

export default SaleSection;
